export default __webpack_public_path__ + "static/media/sip-logotype-l.2a62d888.svg";